/* KYNFORGE Performance — theme.js */
(function () {
  'use strict';

  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach((el) => io.observe(el));
  } else {
    $$('.reveal').forEach((el) => el.classList.add('is-in'));
  }

  /* ---------- Drawers & modals (data-open / data-close) ---------- */
  document.addEventListener('click', (ev) => {
    const open = ev.target.closest('[data-open]');
    if (open) {
      const t = document.getElementById(open.getAttribute('data-open'));
      if (t) { t.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
      return;
    }
    const close = ev.target.closest('[data-close]');
    if (close) {
      const t = close.closest('.drawer, .modal');
      if (t) { t.classList.remove('is-open'); document.body.style.overflow = ''; }
    }
  });
  document.addEventListener('keydown', (ev) => {
    if (ev.key === 'Escape') { $$('.drawer.is-open, .modal.is-open').forEach((t) => t.classList.remove('is-open')); document.body.style.overflow = ''; }
  });

  /* ---------- Marquee: duplicate track content for seamless loop ---------- */
  $$('.marquee__track').forEach((track) => { track.innerHTML += track.innerHTML; });

  /* ---------- Product gallery ---------- */
  $$('[data-gallery]').forEach((gal) => {
    const slides = $$('.gallery__slide', gal);
    const thumbs = $$('.gallery__thumb', gal);
    let i = 0;
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      const th = thumbs[i]; if (th && th.scrollIntoView) th.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    };
    thumbs.forEach((t, k) => t.addEventListener('click', () => go(k)));
    const prev = $('.gallery__arrow--prev', gal), next = $('.gallery__arrow--next', gal);
    if (prev) prev.addEventListener('click', () => go(i - 1));
    if (next) next.addEventListener('click', () => go(i + 1));
    // swipe
    let x0 = null;
    gal.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    gal.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1); x0 = null; });
    go(0);
  });

  /* ---------- Variant picker ---------- */
  $$('[data-product-form]').forEach((form) => {
    const json = $('[data-variants-json]', form);
    if (!json) return;
    let variants = [];
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }
    const idInput = $('input[name="id"]', form);
    const money = (cents) => {
      const fmt = form.getAttribute('data-money-format') || '£{{amount}}';
      const amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, amount.split('.')[0]);
    };
    const update = () => {
      const selected = $$('fieldset', form).map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
      const v = variants.find((x) => selected.every((o, k) => o === null || x.options[k] === o));
      if (!v) return;
      idInput.value = v.id;
      const now = $('[data-price-now]', form), was = $('[data-price-was]', form), pct = $('[data-price-pct]', form);
      if (now) now.textContent = money(v.price);
      if (was) { if (v.compare_at_price && v.compare_at_price > v.price) { was.textContent = money(v.compare_at_price); was.hidden = false; } else { was.hidden = true; } }
      if (pct) { if (v.compare_at_price && v.compare_at_price > v.price) { pct.hidden = false; pct.lastChild.textContent = ' SAVE ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; } else { pct.hidden = true; } }
      const btn = $('[data-add-to-cart]', form), lbl = $('[data-add-label]', form);
      if (btn) { btn.disabled = !v.available; if (lbl) lbl.textContent = v.available ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-sold'); }
      $$('[data-sticky-price]').forEach((el) => { el.textContent = money(v.price); });
      if (history.replaceState) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    };
    form.addEventListener('change', (e) => { if (e.target.matches('input[type="radio"]')) update(); });
    update();
  });

  /* ---------- Sticky add-to-cart (mobile) ---------- */
  const sticky = $('.sticky-atc');
  const atcBtn = $('[data-add-to-cart]');
  if (sticky && atcBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver((en) => { sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(atcBtn);
    $('[data-sticky-go]', sticky)?.addEventListener('click', () => atcBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }));
  }

  /* ---------- Quantity ---------- */
  document.addEventListener('click', (ev) => {
    const b = ev.target.closest('[data-qty]');
    if (!b) return;
    const input = $('input', b.parentElement);
    const n = Math.max(0, (parseInt(input.value, 10) || 0) + (b.getAttribute('data-qty') === '+' ? 1 : -1));
    input.value = n;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  $$('[data-cart-form]').forEach((f) => f.addEventListener('change', (e) => { if (e.target.matches('input[name^="updates"]')) f.submit(); }));

  /* ---------- AJAX add to cart -> update count, then go to cart ---------- */
  $$('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (ev) => {
      if (!window.fetch) return;
      ev.preventDefault();
      const btn = $('[data-add-to-cart]', form);
      btn && (btn.disabled = true);
      try {
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: idOf(form), quantity: qtyOf(form) }] }) });
        if (!r.ok) throw new Error('add failed');
        const c = await fetch('/cart.js').then((x) => x.json());
        $$('[data-cart-count]').forEach((el) => { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
        location.href = form.getAttribute('data-after-add') || '/cart';
      } catch (e) { form.submit(); }
      finally { btn && (btn.disabled = false); }
    });
  });
  function idOf(f) { return $('input[name="id"]', f).value; }
  function qtyOf(f) { const q = $('input[name="quantity"]', f); return q ? parseInt(q.value, 10) || 1 : 1; }

  /* ---------- Urgency viewer count (subtle, deterministic per hour) ---------- */
  $$('[data-viewers]').forEach((el) => {
    const base = parseInt(el.getAttribute('data-viewers'), 10) || 12;
    const h = new Date().getHours();
    el.textContent = base + ((h * 7) % 6) - 2;
  });

  /* ---------- Localization form auto-submit ---------- */
  $$('.localization select').forEach((s) => s.addEventListener('change', () => s.form && s.form.submit()));
})();
